import { useSelector } from 'react-redux'

import { selectProjectConfig } from '@store/actionSlices/projectConfig'
import { selectWhiteLabel } from '@store/actionSlices/whiteLabel'

import mapWhiteLabelsWithDefaults from '@utilities/white-label'

import { getStatusColour } from './level-explorer-util'

const useLevelDisplayConfig = () => {
  const whiteLabel = useSelector(selectWhiteLabel)
  const { statusLabels, statusColors } = useSelector(selectProjectConfig)

  const { levelStagePrefix } =
    mapWhiteLabelsWithDefaults(whiteLabel).propertySidePanel
  const availableStatusLabel = statusLabels?.available

  return {
    levelStagePrefix,
    availableStatusLabel,
    availableStatusColour: getStatusColour(statusColors, availableStatusLabel),
  }
}

export default useLevelDisplayConfig
